import { render } from "./Filtros.vue?vue&type=template&id=1796260c&scoped=true&ts=true"
import script from "./Filtros.vue?vue&type=script&lang=ts"
export * from "./Filtros.vue?vue&type=script&lang=ts"

import "./Filtros.vue?vue&type=style&index=0&id=1796260c&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1796260c"]])

export default __exports__